<template>
  <v-sheet>

    <br>
    <br>
    <br>
    <v-icon
        class="mb-5"
        color="success"
        icon="mdi-check-circle"
        size="112"
    ></v-icon>
    <br>
    <v-card-title>Успешная покупка</v-card-title>


    <v-sheet width="320px" class="d-inline-flex flex-column justify-start">
      <v-form>

        <v-card-text>
          Ваши билеты отправлены на почту
        </v-card-text>

        <v-btn @click="close">
          OK
        </v-btn>
        <br>
        <br>
      </v-form>
    </v-sheet>


  </v-sheet>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-facing-decorator';
import {closeWidget} from "@/utils";

@Component
export default class Success extends Vue {
  close = closeWidget
}
</script>
